/**
 * Which of the three deployments this bundle was built for.
 *
 * The frontend has no environment variable of its own. `VITE_API_BASE` is the
 * only build-time value that already differs across all three, and both deploy
 * workflows pass it explicitly — `https://honeyguide.cool` from
 * `deploy-prod.yml`, `https://staging.honeyguide.cool` from
 * `deploy-staging.yml`, and a clone's own host from `frontend/.env.development`
 * (`docs/deploy_environments.md`). A second build arg kept in step with the
 * first would be one more thing to get wrong on a deploy.
 *
 * **Unknown means production.** An absent or empty base reads as prod, which
 * matches the Dockerfile's `ARG VITE_API_BASE` default: a bare `docker build`
 * with no build args produces the production bundle. So the safer reading of
 * "I don't know where I am" is the one that hides things rather than the one
 * that shows them.
 */
export const PRODUCTION_API_BASE = 'https://honeyguide.cool'

/**
 * The decision itself, over a base passed in.
 *
 * Split from `isProduction` so the unset case is reachable from a test. A
 * default parameter cannot distinguish "not passed" from "passed undefined",
 * so with the env read inline there was no way to exercise the branch that
 * matters most.
 */
export const isProductionApiBase = (apiBase: string | undefined): boolean => {
  const base = (apiBase ?? '').trim().replace(/\/+$/, '')
  return base === '' || base === PRODUCTION_API_BASE
}

/** The decision for this bundle. */
export const isProduction = (): boolean =>
  isProductionApiBase(import.meta.env.VITE_API_BASE)
